import { NgModule } from '@angular/core'
import { BaseComponentDirective } from './components/base.component'
import { OneValidFieldPipe } from './pipes/one-valid-field.pipe'
@NgModule({
  declarations: [BaseComponentDirective, OneValidFieldPipe],
  imports: [],
  exports: [BaseComponentDirective, OneValidFieldPipe],
})
export class CoreModule {}
